import { put, apply, select, call, takeEvery, all } from 'redux-saga/effects'
import { createAction, createReducer } from 'redux-act'
import { get } from 'lodash'

import { selector as configSelector } from '~/config'

import API from '~/api'

import { Entity, handleError } from '~/utils/entity-utils'

// ACTIONS
export const actions = {
  fetchList: {
    request: createAction('fetch order chart items', (shop, params) => ({shop, params})),
    failure: createAction('fetch order chart items failure', (message, response) => ({message, response})),
    success: createAction('fetch order chart items success', (shop, chartItems, response) => ({shop, chartItems, response})),
  }
};

// WORKERS
export const workers = {
  * fetchListWorker(action, throwError = false) {
    const {shop, params} = get(action, 'payload', {});
    try {

      const config = yield select(configSelector);
      const api = new API(config);
      let requestParams = {
        ...params,
        shop
      };
      const response = yield apply(api, api.callRoute, ['orders/chart/', 'GET', null, requestParams]);

      yield put(actions.fetchList.success(shop, response.data, response));

      return response.data;
    } catch (e) {
      yield call(handleError, e, actions.fetchList);
      if(throwError) {
        throw e;
      }else {
        return e;
      }
    }
  }
};

// SAGA
export function * saga() {
  yield all([
    takeEvery(actions.fetchList.request().type, workers.fetchListWorker)
  ]);
}

export const reducer = createReducer({
  [actions.fetchList.success]: (state, payload) => {
    if(payload['chartItems'] && payload['shop']) {
      const { chartItems, shop } = payload;
      let newState = Object.assign({}, state);
      newState[shop] = chartItems;
      return newState
    }
    return state;
  },
}, {});

export default {
  actions,
  workers,
  saga,
  reducer
}